/**
 * Sanitizes a numeric value to ensure it is finite and non-negative.
 * Handles NaN, Infinity, -Infinity, undefined, null, and negative numbers.
 *
 * @param value - The value to sanitize (can be any type)
 * @param fallback - The fallback value to use when the input is not a finite number (default: 0)
 *                   The fallback itself is validated to be finite and non-negative
 * @returns A finite, non-negative number
 */
export function sanitizeNumber(value: any, fallback: number = 0): number {
  // Normalize fallback: ensure it's finite and non-negative, otherwise use 0
  const fallbackNum = Number(fallback);
  const safeFallback = Number.isFinite(fallbackNum) ? Math.max(0, fallbackNum) : 0;

  // Sanitize the input value
  const num = Number(value);
  return Number.isFinite(num) ? Math.max(0, num) : safeFallback;
}
